import { configureStore } from "@reduxjs/toolkit"
import dataInfoReducer from "../slices/dataInfoSlice"
import dataCartReducer from "../slices/dataCartSlice"
import ticketReducer from "../slices/tickketSlice"


const store = configureStore({
    reducer: {
        dataInfoReducer,
        dataCartReducer,
        ticketReducer
    },
})

export default store